<template>
    <div class="video_h5R">
       <aliPlayer></aliPlayer>   
    </div>
</template>
<script>
import aliPlayer from "components/aliPlayer"

export default {
    name:"Video",
    data() {
        return {
            source:'', //视频地址    
        }
    },
    created(){
        this.source = this.cur_data.file_path[0];
        this.$store.commit('video_url',this.source);
    },
    computed: {
        video_finished() {
            return this.$store.state.video_finished;
        },
        cur_data() {
            return this.$store.state.cur_data;
        },
        next_data() {
            return this.$store.state.next_data;
        },
        cur_chap_index(){
            return this.$store.state.currentChapterIndex;
        },
        cur_part_index(){
            return this.$store.state.currentPartIndex;
        },
        
    },
    watch:{
        video_finished() {
            // debugger
            if(this.$store.state.video_finished){
                let curPartIndex = Number(this.cur_part_index);
                let curChapIndex = Number(this.cur_chap_index);
                let nexPartIndex = curPartIndex;
                let nexChapIndex = curChapIndex;
                if(curChapIndex < this.data.part_list[curPartIndex].chapter_list.length - 1) {
                  curChapIndex = curChapIndex+1;
                } else if(curPartIndex < this.data.part_list.length - 1) {
                  curPartIndex = curPartIndex+1;
                  curChapIndex = 0;
                } else {
                    this.$store.commit('cur_data',{
                        chapter_type: -2,
                        activeShow: -1,
                        type: 'end'
                    });
                    return this.$router.replace('/h5Rindex/footVideo');
                    // this.lookFootVideo()
                }
                if(curChapIndex < this.data.part_list[curPartIndex].chapter_list.length - 1) {
                    nexPartIndex = curPartIndex;
                    nexChapIndex = curChapIndex +1;
                } else if(curPartIndex < this.data.part_list.length - 1) {
                    nexPartIndex = curPartIndex + 1;
                    nexChapIndex = 0;
                }
                this.$store.commit('cur_data', this.next_data);
                this.$store.commit('currentChapterIndex',curChapIndex);
                this.$store.commit('currentPartIndex',curPartIndex);
                this.$store.commit('next_data',this.data.part_list[nexPartIndex].chapter_list[nexChapIndex]);
                this.$store.commit('chapterNumCur',this.$store.state.chapterNumCur + 1)
                
                if(this.cur_data.chapter_type == 1){ //视频类型
                    this.source = this.cur_data.file_path[0];
                    this.$store.commit('video_url',this.source);
                    this.$router.push('/h5Rindex/video');
                }else if(this.cur_data.chapter_type == 2){ //小测验
                    // this.$store.commit('quiz_type', this.next_data.chapter_content.quiz_type);
                    this.$router.push('/h5Rindex/test');
                }else {
                    //图文 4
                    this.$router.push('/h5Rindex/tuwen');
                } 

                

            }
        },
        cur_data(){
            if(this.cur_data.file_path){
                this.source = this.cur_data.file_path[0];
                this.$store.commit('video_url',this.source);
             }
        },
        
  
    },
    methods: {

    },
    components:{
        aliPlayer
    }
}
</script>
<style lang="less" scoped>
    .video_h5R {
        padding:.2rem 1.2rem;
        height: calc(100% - .8rem);
        box-sizing: border-box;
        .aliplayer {
            height: 100%;
            min-height: 3rem;
        }
    }
</style>
